import { jsx as I, Fragment as j, jsxs as z } from "react/jsx-runtime";
import E, { useState as v, useRef as S, useCallback as R, useEffect as p } from "react";
import { List as $, ListItem as q } from "@rmwc/list";
import { useFoundation as F, closest as N, raf as U, emptyClientRect as W, createComponent as x, useClassNames as P, PortalChild as X, Tag as _, classNames as Y, getDisplayName as J } from "@rmwc/base";
import { MDCMenuSurfaceFoundation as w } from "@material/menu-surface";
import { getCorrectPropertyName as Q } from "@material/animation";
import { MDCMenuFoundation as Z } from "@material/menu";
const ee = {
  bottomEnd: "BOTTOM_END",
  bottomLeft: "BOTTOM_LEFT",
  bottomRight: "BOTTOM_RIGHT",
  bottomStart: "BOTTOM_START",
  topEnd: "TOP_END",
  topLeft: "TOP_LEFT",
  topRight: "TOP_RIGHT",
  topStart: "TOP_START"
}, ne = (t) => w.Corner[ee[t]], te = (t, o) => {
  const [r, a] = v(t.open), O = S(null), l = S(null), f = S(null), g = S(null), { foundation: s, ...y } = F({
    props: t,
    elements: { rootEl: !0 },
    api: ({
      foundation: e,
      rootEl: u
    }) => ({
      setAnchorCorner: (m) => e.setAnchorCorner(m),
      setAnchorElement: (m) => f.current = m,
      setOpen: (m) => a(m),
      getSurfaceElement: () => u.ref
    }),
    foundation: ({ rootEl: e, getProps: u, emit: m }) => {
      const T = (c) => {
        s.handleBodyClick(c);
      }, i = () => {
        setTimeout(() => {
          document.body.addEventListener("click", T), document.body.addEventListener("touchstart", T);
        }, 150);
      }, n = () => {
        document.body.removeEventListener("click", T), document.body.removeEventListener("touchstart", T);
      }, d = () => ({
        isFocused: () => document.activeElement === e.ref,
        saveFocus: () => {
          l.current = document.activeElement;
        },
        restoreFocus: () => {
          e.ref && e.ref.contains(document.activeElement) && l.current && l.current.focus && l.current.focus();
        }
      }), b = () => ({
        getInnerDimensions: () => ({
          width: e.ref ? e.ref.offsetWidth : 0,
          height: e.ref ? e.ref.offsetHeight : 0
        }),
        getAnchorDimensions: () => {
          var c;
          return ((c = f.current) == null ? void 0 : c.getBoundingClientRect()) || W;
        },
        getWindowDimensions: () => ({
          width: window.innerWidth,
          height: window.innerHeight
        }),
        getBodyDimensions: () => ({
          width: document.body.clientWidth,
          height: document.body.clientHeight
        }),
        getWindowScroll: () => ({ x: window.pageXOffset, y: window.pageYOffset }),
        setPosition: (c) => {
          e.setStyle(
            "left",
            c.left !== void 0 ? c.left : null
          ), e.setStyle(
            "right",
            c.right !== void 0 ? c.right : null
          ), e.setStyle(
            "top",
            c.top !== void 0 ? c.top : null
          ), e.setStyle(
            "bottom",
            c.bottom !== void 0 ? c.bottom : null
          );
        },
        setMaxHeight: (c) => {
          e.setStyle("maxHeight", c);
        }
      }), M = new w({
        addClass: (c) => {
          e.addClass(c);
        },
        removeClass: (c) => {
          e.removeClass(c);
        },
        hasClass: (c) => c === "mdc-menu-surface" ? !0 : e.hasClass(c),
        hasAnchor: () => !!f.current,
        notifyClose: () => {
          n(), a(!1);
        },
        notifyClosing: () => m(w.strings.CLOSING_EVENT, {}),
        notifyOpen: () => {
          m("onOpen", {}), i();
        },
        notifyOpening: () => m(w.strings.OPENING_EVENT, {}),
        isElementInContainer: (c) => e.ref === c || !!e.ref && e.ref.contains(c),
        isRtl: () => !!e.ref && getComputedStyle(e.ref).getPropertyValue("direction") === "rtl",
        setTransformOrigin: (c) => {
          const V = `${Q(
            window,
            "transform"
          )}-origin`;
          e.setStyle(V, c);
        },
        ...d(),
        ...b()
      }), B = M.close.bind(M), G = (c = !1) => {
        m("onClose", {}), g.current = window.setTimeout(() => {
          u().open || B(c);
        });
      };
      M.close = G;
      const K = M.destroy.bind(M);
      return M.destroy = () => {
        n(), K();
      }, M;
    }
  }), { rootEl: C } = y, { onKeyDown: h } = t, A = R(
    (e) => {
      h == null || h(e), s.handleKeydown(e);
    },
    [h, s]
  );
  return C.setProp("onKeyDown", A, !0), p(() => {
    s.setFixedPosition(!!t.fixed);
  }, [t.fixed, s]), p(() => {
    const e = (o == null ? void 0 : o.current) || C.ref;
    if (e) {
      const u = N(
        e,
        `.${w.cssClasses.ANCHOR}`
      );
      u && (f.current = u);
    }
  }, [o, C.ref]), p(() => {
    t.renderToPortal ? s.setIsHoisted(!0) : s.setIsHoisted(!1);
    const e = () => {
      try {
        s.autoposition();
      } catch {
      }
    }, u = t.renderToPortal ? e : () => {
    };
    return U(() => {
      s.isOpen();
    }), window.addEventListener("resize", u), () => {
      window.removeEventListener("resize", u);
    };
  }, [t.renderToPortal, s]), p(() => {
    const e = t.anchorCorner && ne(t.anchorCorner);
    if (e !== void 0) {
      s.setAnchorCorner(e), s.dimensions = s.adapter.getInnerDimensions();
      try {
        s.autoposition();
      } catch {
      }
    }
  }, [t.anchorCorner, s]), p(() => {
    if (r) {
      const e = C.ref ? C.ref.querySelectorAll(
        w.strings.FOCUSABLE_ELEMENTS
      ) : [];
      O.current = e.length > 0 ? e[0] : null, s.open();
    } else
      s.isOpen() && s.close();
  }, [r, s, C.ref]), p(() => {
    a(!!t.open);
  }, [t.open]), p(() => () => {
    g.current && window.clearTimeout(g.current);
  }, []), { ...y };
}, D = x(
  function(o, r) {
    const {
      children: a,
      open: O,
      anchorCorner: l,
      onOpen: f,
      onClose: g,
      renderToPortal: s,
      fixed: y,
      apiRef: C,
      foundationRef: h,
      ...A
    } = o, e = E.useRef(null), { rootEl: u } = te(
      o,
      e
    ), m = P(o, [
      "mdc-menu-surface",
      {
        "mdc-menu-surface--fixed": y
      }
    ]);
    return /* @__PURE__ */ I(j, { children: /* @__PURE__ */ I(
      X,
      {
        renderTo: s,
        menuSurfaceDomPositionRef: e,
        children: /* @__PURE__ */ I(_, { ...A, element: u, className: m, ref: r, children: a })
      }
    ) });
  }
), oe = x(
  function(o, r) {
    const a = P(o, ["mdc-menu-surface--anchor"]);
    return /* @__PURE__ */ I(_, { ...o, className: a, ref: r });
  }
), re = (t) => {
  const o = S(), r = S(), a = (i) => {
    r.current = i;
  }, O = (i) => {
    o.current = i;
  }, l = R(() => {
    var i;
    return ((i = r.current) == null ? void 0 : i.listElements()) || [];
  }, []), { foundation: f, ...g } = F({
    props: {
      ...t,
      // we don't want to pass the apiRef all the way through
      apiRef: void 0
    },
    elements: {
      rootEl: !0
    },
    foundation: ({ emit: i }) => new Z({
      addClassToElementAtIndex: (...n) => {
        var d;
        return (d = r.current) == null ? void 0 : d.addClassToElementIndex(...n);
      },
      removeClassFromElementAtIndex: (...n) => {
        var d;
        return (d = r.current) == null ? void 0 : d.removeClassFromElementAtIndex(...n);
      },
      addAttributeToElementAtIndex: (...n) => {
        var d;
        return (d = r.current) == null ? void 0 : d.setAttributeForElementIndex(...n);
      },
      removeAttributeFromElementAtIndex: (n, d) => {
        l()[n].removeAttribute(d);
      },
      elementContainsClass: (n, d) => n.classList.contains(d),
      closeSurface: () => {
        var n;
        (n = o.current) == null || n.setOpen(!1);
      },
      getElementIndex: (n) => l().indexOf(n),
      notifySelected: (n) => i("onSelect", {
        index: n.index,
        item: l()[n.index]
      }),
      getMenuItemCount: () => {
        var n;
        return ((n = r.current) == null ? void 0 : n.getListItemCount()) || 0;
      },
      focusItemAtIndex: (...n) => {
        var d;
        return (d = r.current) == null ? void 0 : d.focusItemAtIndex(...n);
      },
      focusListRoot: () => {
        var n;
        return (n = r.current) == null ? void 0 : n.focusRoot();
      }
    })
  }), { rootEl: s } = g, { onClick: y } = t, C = R(
    (i) => {
      y == null || y(i);
      const n = N(i.target, ".mdc-deprecated-list-item");
      n && f.handleItemAction(n);
    },
    [f, y]
  ), { onKeyDown: h } = t, A = R(
    (i) => {
      h == null || h(i), f.handleKeydown(i), i.which === 13 && i.target instanceof Element && r.current && i.target.classList.contains(r.current.getClasses()) && f.handleItemAction(i.target);
    },
    [f, h]
  ), { onOpen: e, focusOnOpen: u } = t, m = R(
    (i) => {
      const n = l();
      (u || u === void 0) && n.length > 0 && !n.some((d) => d === document.activeElement) && n[0].focus(), e == null || e(i);
    },
    [e, u, l]
  );
  s.setProp("onKeyDown", A, !0), s.setProp("onClick", C, !0), s.setProp("onOpen", m, !0);
  const T = r.current && o.current && t.apiRef;
  return p(() => {
    r.current && o.current && t.apiRef && t.apiRef({
      ...r.current,
      ...o.current,
      items: l
    });
  }, [T, l]), { setListApi: a, setMenuSurfaceApi: O, ...g };
}, H = x(
  function(o, r) {
    const a = P(o, ["mdc-list mdc-menu__items"]);
    return /* @__PURE__ */ I($, { role: "menu", ...o, className: a, ref: r });
  }
);
H.displayName = "MenuItems";
const fe = x(
  function(o, r) {
    return /* @__PURE__ */ I(q, { role: "menuitem", tabIndex: 0, ...o, ref: r });
  }
), L = (t) => J(t) === "MenuItems", se = x(function(o, r) {
  const { children: a, focusOnOpen: O, onSelect: l, foundationRef: f, ...g } = o, { rootEl: s, setListApi: y, setMenuSurfaceApi: C } = re(o), h = (E.Children.map(a, L) || []).every((e) => e === !1), A = {
    apiRef: y
  };
  return /* @__PURE__ */ I(
    D,
    {
      ...s.props(g),
      className: Y("mdc-menu", g.className),
      apiRef: C,
      ref: r,
      children: h ? /* @__PURE__ */ I(H, { ...A, children: a }) : E.Children.map(a, (e) => L(e) ? E.cloneElement(e, {
        ...E.isValidElement(e) ? e.props : {},
        ...A
      }) : e)
    }
  );
}), k = (t) => function(o) {
  const [r, a] = v(!!o.open);
  p(() => {
    o.open !== void 0 && o.open !== r && a(!!o.open);
  }, [o.open, r]);
  const {
    handle: O,
    onClose: l,
    children: f,
    rootProps: g = {},
    open: s,
    foundationRef: y,
    ...C
  } = o, h = E.cloneElement(O, {
    ...O.props,
    onClick: (u) => {
      a(!r), O.props.onClick && O.props.onClick(u);
    }
  });
  return /* @__PURE__ */ z(oe, { ...g, children: [
    /* @__PURE__ */ I(
      t,
      {
        ...C,
        onClose: (u) => {
          a(!!s || !1), l == null || l(u);
        },
        open: r,
        children: f
      }
    ),
    h
  ] });
}, he = k(se), Ce = k(D);
export {
  se as Menu,
  fe as MenuItem,
  H as MenuItems,
  D as MenuSurface,
  oe as MenuSurfaceAnchor,
  he as SimpleMenu,
  Ce as SimpleMenuSurface
};
